/** Guards for the DOMException names media playback rejects with for reasons that are NOT
 *  asset failures — reporting them burns this src's single report and hides the real
 *  failure. */

function hasErrorName(error: unknown, name: string): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as { name?: unknown }).name === name
  );
}

/** `pause()`, `load()` or `destroy()` interrupting a still-pending `play()`/fetch rejects
 *  with `AbortError` — an expected interruption, not a playback failure. */
export function isAbortError(error: unknown): boolean {
  return hasErrorName(error, 'AbortError');
}

/** `play()` on an element whose `src` is not set yet (or is undecodable) rejects with
 *  `NotSupportedError`. Engines that assign the source only after their own fetch resolves
 *  (WaveSurfer) hit this on a tap that lands before decode — a race. */
export function isNotSupportedError(error: unknown): boolean {
  return hasErrorName(error, 'NotSupportedError');
}

/** The autoplay/gesture policy refusing a programmatic `play()` rejects with
 *  `NotAllowedError` — routine on iOS and in every Capacitor WebView, and it says nothing
 *  about the asset. */
export function isNotAllowedError(error: unknown): boolean {
  return hasErrorName(error, 'NotAllowedError');
}
